/**
 * **Xcaliber**
 *
 * @exports bs_285
 * @category engines
 */
function factory({ window, document, thn }) {

  const engine = {};

  /**
     * @memberOf module:bs_285
     * @see {@link language_check}
     *
     * @param {object} ctx - The context object.
     */
  engine.languageCheck = function languageCheck(ctx) {
    const xcaliberData = window.Xcaliber;

    return new Promise(function (resolve, reject) {
      const aux = xcaliberData && xcaliberData.language && xcaliberData.language.slice(0, 2);

      if (aux === 'jp') {
        resolve('ja');
        return;
      }

      if (aux && ctx.langs.test(aux)) {
        resolve(aux);
        return;
      }

      reject('no_language');
    });
  };

  /**
     * @memberOf module:bs_285
     * @see {@link onStateChange}
     *
     * @param {object} ctx - The context object.
     */
  engine.onStateChange = function onStateChange(ctx) {
    setTimeout(thn.pageCheck, 400);
  };

  /**
     * @memberOf module:bs_285
     * @see {@link is_user_logged}
     *
     * @param {object} ctx - The context object.
     */
  engine.isUserLogged = function isUserLogged(ctx) {

    let isLogged = false;
    const loginSelector = document.querySelector('.alert.alert-secondary.alert-user-mb');

    if (loginSelector && !loginSelector.classList.contains('ng-hide') // so far, just founded a login feature for hotel Suni Sicogon
    ) {
      isLogged = true;
    }

    return isLogged;
  };

  /**
   * @memberOf module:bs_285
   * @see {@link generate_search_url}
   *
   * @param {object} ctx - The context object.
   */
  engine.generateSearchUrl = function generateSearchUrl(ctx) {
    // https://www.myxcaliber.com/ibe/b/The-Amethyst-Hotel-Pattaya#/room/25%20Jan%2024/26%20Jan%2024
    const url = new URL(ctx.baseUrl);
    const validUrl = url.pathname.match(/ibe/);

    if (!validUrl) {
      ctx.newUrl = '';
      return ctx;
    }

    ctx.newUrl = url.toString();

    return ctx;
  };

  /**
     * @memberOf module:bs_285
     * @this thn.widgets.price
     * @see {@link Price#observe_dom}
     *
     * @param {object} ctx - The context object.
     */
  engine.priceObserveDom = function priceObserveDom(ctx) {
    const container = document.querySelector('.view-container, #room_list');

    if (container && !thn.xcaliberObserver) {
      thn.xcaliberObserver = thn.debounce(function () {
        thn.pageCheck();
        if (thn.data.pageName === 'Rooms and Rates') {
          thn.widgets.price.refresh();
        }
      }, 500);
    }

    thn.observeDom(container, thn.xcaliberObserver, {
      childList: true,
      subtree: true,
    });

    thn.pageUnload(() => {
      thn.stopObserveDom(container, thn.xcaliberObserver);
      delete thn.xcaliberObserver;
    });
  };

  /**
     * @memberOf module:bs_285
     * @this thn.widgets.price
     * @see {@link Price#set_data}
     *
     * @param {object} ctx - The context object.
     */
  engine.priceParseData = function priceParseData(ctx) {

    const widgetData = {};
    const xcaliberData = window.Xcaliber;

    // Dates
    // Date begin formats: "24 Mar 20" english, "24 thg 3 20" thai, "24-3-20" others

    const dateEnd = (document.querySelector('#checkout input') || {})?.value;
    const nightsEl = document.querySelector('#check-nights');
    const nights = thn.parseNumber((nightsEl?.options[nightsEl?.selectedIndex] || document.querySelector('.night'))?.textContent);

    if (dateEnd && nights) {
      widgetData.dateEnd = dateEnd.replace(/(\d+)\/(\d+)\/(\d+)/, '$3/$1/$2');
      widgetData.dateBegin = thn.dateToString(thn.addDays(widgetData.dateEnd, -nights));
    } else if (nights) {
      let dateEndDay = document.querySelector('.ui-datepicker-current-day')?.textContent;
      let dateEndMonth = document.querySelector('.ui-datepicker-month [selected]')?.value;
      dateEndMonth = dateEndMonth ? thn.parseNumber(dateEndMonth) + 1 : undefined;
      dateEndMonth = dateEndMonth < 10 ? `0${dateEndMonth}` : dateEndMonth;
      dateEndDay = dateEndDay < 10 ? `0${dateEndDay}` : dateEndDay;
      const dateEndYear = document.querySelector('.ui-datepicker-year [selected]')?.value;
      widgetData.dateEnd = dateEndYear && dateEndMonth && dateEndDay && `${dateEndYear}/${dateEndMonth}/${dateEndDay}`;
      widgetData.dateBegin = widgetData.dateEnd && thn.dateToString(thn.addDays(widgetData.dateEnd, -nights));
    }
    if (!widgetData.dateEnd) { // if there is no dateEnd element, the default dates are today and tomorrow
      widgetData.dateBegin = thn.dateToString((new Date()).toDateString());
      widgetData.dateEnd = thn.dateToString(thn.addDays(widgetData.dateBegin, 1));
    }

    // Guests, Adults & Children
    const adults = (document.querySelector('.panel-heading div.ng-binding'))?.textContent;
    widgetData.adults = (adults && thn.parseNumber(adults)) || 2;
    widgetData.children = 0;
    widgetData.guests = widgetData.adults + widgetData.children;

    // Prices & Currency || No Rooms
    const prices = [...document.querySelectorAll('.x-price, .price')].filter(thn.isVisible).map((el) => thn.parseNumber(el.textContent));

    if (prices.length) {
      widgetData.price = Math.min(...prices);
      widgetData.currency = (xcaliberData && xcaliberData.currency) || 'THB';
      widgetData.roomDetails = engine._roomDetailsParseData();
      widgetData.set = true;
    } else {
      widgetData.noRooms = true;
    }

    return widgetData;
  };

  /**
     *
     * @memberOf module:bs_285
     *
     */
  engine._roomDetailsParseData = function roomDetailsParseData() {
    let roomDetailsArray = [];
    const roomSelector = [...document.querySelectorAll('.well.well-white:not(.ng-hide)')];

    roomDetailsArray = roomSelector.map((room) => {
      const roomName = ((room.querySelector('.control-label') || {}).textContent || '').trim();
      const roomAdults = thn.parseNumber((room.querySelector('.panel-heading div.ng-binding') || {}).textContent);
      const roomChildren = 0;
      const roomPrice = [...room.querySelectorAll('div.xpanel-discount:not(.ng-hide) .panel-body.clearfix')].map((priceEl) => {
        const priceName = (priceEl.querySelector('.x-clickable .ng-binding') || {}).textContent || '';
        const priceTotal = thn.parseNumber((priceEl.querySelector('.x-price') || {}).textContent) || 0;
        if (!priceName) {
          return false;
        }

        return {
          id: '',
          name: priceName,
          price: priceTotal,
          refundable: 1, // All rooms are refundable if the cause is reflected in your cancellation policy.
        };

      }).filter(Boolean);

      if (!roomName || !roomAdults || !roomPrice.length) {
        return false;
      }

      return {
        id: '',
        name: roomName,
        adults: roomAdults,
        children: roomChildren,
        price: roomPrice,
        type: (roomName.match(/Superior/i)) ? 'Superior' : 'Deluxe',
      };

    }).filter(Boolean);

    return roomDetailsArray;
  };

  /**
     * @memberOf module:bs_285
     * @this thn.widgets.booking
     * @see {@link Booking#set_data}
     *
     * @param {object} ctx - The context object.
     */
  engine.bookingParseData = function bookingParseData(ctx) {

    const widgetData = {};
    const xcaliberData = window.Xcaliber;

    const price = (document.querySelector('strong.ng-binding') || {}).textContent || '';

    widgetData.bookingId = (xcaliberData && xcaliberData.cartId) || thn.parseUrlParameter('id');
    widgetData.price = price && thn.parseNumber(price);
    widgetData.currency = [1029898, 1029907].includes(thn.data.propertyId) ? 'VND' : 'THB';

    return widgetData;
  };

  return engine;

}

export { factory };
